import React from "react";
import "./StudioOwnAbout.css";
import StudioOwnAboutLogo from "../../../assets/studioownlogo.png";

function StudioOwnAbout() {
  return (
    <div className="studio-own-about-container">
      <div className="studio-own-about-content">
        <a
          href="http://studioown.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="studio-own-about-logo-container">
            <img
              src={StudioOwnAboutLogo}
              alt="StudioOwnAboutLogo"
              className="studio-own-about-logo"
            />
          </div>
        </a>

        <div className="studio-own-about-text-container">
          <h1 className="studio-own-about-main-title">StudioOwn.com</h1>
          <p className="studio-own-about-descriptions">
            Enter Studio Own, where complete studio infrastructures and news
            channels materialize as a testament to our commitment.
            <br />
            <br />
            Broadcasting rooms, talk shows, broadcasting and streaming channels,
            social media networks, sound mixing, movie editing, songwriting, and
            song recording converge within this realm.
            <br />
            <br />
            In every hour, in every aspect that embodies the studio's essence,
            our services come to life.
            <br />
            <br />
            Trust Studio Own to orchestrate the symphony of audiovisual
            excellence, where innovation and precision synchronize to craft
            narratives that resonate globally.
          </p>
        </div>
      </div>
    </div>
  );
}

export default StudioOwnAbout;
